export const obtenerNumNoches = ({fechaCheckIn, fechaCheckOut}) => {

    let unaHoraMilisegundos = 1000 * 60 * 60
    let unDiaMilisegundos = unaHoraMilisegundos * 24

    let horaSalidaMasUnaHora = fechaCheckOut + unaHoraMilisegundos + (1000 * 60 * 3)

    let tiempoEstadiaMilisegundos = horaSalidaMasUnaHora - fechaCheckIn

    let diasEstadia = tiempoEstadiaMilisegundos / unDiaMilisegundos

    return diasEstadia.toFixed(0)

}